<template>
  <div id="app">
    <router-view></router-view>

    <!-- Footer 部分 -->
    <footer class="footer bg-gray-100">
      <div class="footer-content">
        <p class="copyright">&copy; {{ new Date().getFullYear() }} BESTREADER.AI. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import { SUPPORTED_LOCALES } from './constants/locales';

export default {
  name: 'App',
  // 如果使用 vue-meta，可以这样动态更新头部
  metaInfo() {
    // 获取当前路由信息
    const currentLocale = this.$route.path.split('/')[1] || 'zh';
    const baseTitle = this.$t('interface.ai_inspiration_hub');
    
    return {
      htmlAttrs: {
        lang: currentLocale
      },
      // 设置基础 meta 信息
      title: baseTitle,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('meta.description')
        },
        {
          vmid: 'og:locale',
          property: 'og:locale',
          content: currentLocale
        }
      ],
      link: [
        ...this.getAlternateLinks()
      ]
    }
  },
  methods: {
    getAlternateLinks() {
      const baseUrl = 'https://hub.bestreader.ai';
      const currentPath = this.$route.path;
      const pathWithoutLang = currentPath.split('/').slice(2).join('/');
      
      // 基础语言版本
      const links = SUPPORTED_LOCALES.map(lang => ({
        rel: 'alternate',
        hreflang: lang === 'zh' ? 'zh-CN' : lang,
        href: `${baseUrl}/${lang}/${pathWithoutLang}`
      }));
      
      // 添加 x-default
      links.push({
        rel: 'alternate',
        hreflang: 'x-default',
        href: `${baseUrl}/zh/${pathWithoutLang}`  // 使用中文作为默认版本
      });
      
      return links;
    }
  }
};
</script>

<style scoped>
/* 设置 footer 的样式 */
.footer {
  padding: 1rem;
  color: #666;
  font-size: 0.9rem;
  margin-top: 0rem;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}
</style>